module.exports = __webpack_public_path__ + "static/media/ybfFlag.56468acd.svg";